import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=11f85576&scoped=true&"
import script from "./DashboardView.ts?vue&type=script&lang=ts&"
export * from "./DashboardView.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardView.scss?vue&type=style&index=0&id=11f85576&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f85576",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VDialog,VProgressLinear})
